"use client";
import type { ReactNode } from "react";
import { AuthProvider } from "./legacy/auth-provider";
import { LegacyAuthBridge } from "./legacy";

import type { AuthConfig } from "./types";
import { KitAuth } from "./kit-auth";

type DotcomAuthProviderProperties = {
  authConfig: AuthConfig;
  children: ReactNode;
};

export const DotcomAuthProvider = ({
  authConfig,
  children,
}: DotcomAuthProviderProperties) => {
  if (authConfig.USE_KIT_AUTH) {
    return <KitAuth authConfig={authConfig}>{children}</KitAuth>;
  }

  // Legacy auth flow. Remove once Kit Auth is 100% in prod.
  return (
    <AuthProvider
      authConfig={authConfig}
      fullStoryOrgId={authConfig.IS_PRODUCTION ? "4HV1Q" : "JMN70"}
    >
      <LegacyAuthBridge>{children}</LegacyAuthBridge>
    </AuthProvider>
  );
};
